export function cnpjMask(value) {
  const clean = value.toUpperCase().replace(/[^0-9A-Z]/g, '');
  const body = clean.slice(0, 12);
  const dv = clean.slice(12, 14).replace(/[^0-9]/g, ''); // DV somente numérico

  let formattedValue = body + dv;
  formattedValue = formattedValue.replace(/^([0-9A-Z]{2})([0-9A-Z])/, '$1.$2');
  formattedValue = formattedValue.replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, '$1.$2.$3');
  formattedValue = formattedValue.replace(/\.([0-9A-Z]{3})([0-9A-Z])/, '.$1/$2');
  formattedValue = formattedValue.replace(/([0-9A-Z]{4})([0-9])/, '$1-$2');

  return formattedValue;
}
